// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const ChartOfAccountsPage = lazy(() => import('./pages/ChartOfAccountsPage'));
const JournalEntriesPage = lazy(() => import('./pages/JournalEntriesPage'));
const BalanceSheetPage = lazy(() => import('./pages/BalanceSheetPage'));
const TrialBalancePage = lazy(() => import('./pages/TrialBalancePage'));

export const GlRoutes: RouteObject = {
  path: 'gl',
  element: <ModuleGuard moduleId="finance.gl" />,
  children: [
    { path: 'chart-of-accounts', element: <ChartOfAccountsPage />, handle: { crumb: 'Chart Of Accounts' } },
    { path: 'journal-entries', element: <JournalEntriesPage />, handle: { crumb: 'Journal Entries' } },
    { path: 'balance-sheet', element: <BalanceSheetPage />, handle: { crumb: 'Balance Sheet' } },
    { path: 'trial-balance', element: <TrialBalancePage />, handle: { crumb: 'Trial Balance' } },
  ],
};
